var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDefaultAvatar5 = function SvgDefaultAvatar5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 55.7c6.3 0 11.3-4.1 11.3-9.8 0-5.5-4.3-9.5-12.2-9.5-.7 0-1.8 0-3 .2.3-1.9.8-5 1.3-7.4h10c2 0 2.8-1.3 2.8-3 0-1.2-.5-1.6-1.1-1.6-.4 0-.9.2-1.3.5H35.5c-1.5 0-1.9.3-2.1 1.3-.7 4-1.9 11.2-1.9 12.5 0 .9.5 1.3 1.4 1.3.8 0 1.9-.2 3.2-.2 5.6 0 8.7 2.6 8.7 6.3 0 3.3-2.7 6-7 6-3.7 0-5.5-1.8-6.8-1.8-.8 0-1.2.6-1.2 1.3 0 2 4.7 3.9 8.7 3.9z"
  })));
};
export default SvgDefaultAvatar5;